import script from "./QueueActivityDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QueueActivityDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./QueueActivityDetailPage.vue?vue&type=style&index=0&id=0a6ce6e9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a6ce6e9"]])

export default __exports__